import { Injectable } from '@angular/core';
import { IID_MAIL_GTW_SOURCE } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDMailGtwStore } from './iidMailGtw.store';
import { IIDMailGtwQuery } from './iidMailGtw.query';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.MAIL_GTW_SOURCE)
export class IIDMailGtwService extends CrudService<IID_MAIL_GTW_SOURCE, IIDMailGtwStore, IIDMailGtwQuery> {
  constructor(
    protected store: IIDMailGtwStore,
    public query: IIDMailGtwQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_MAIL_GTW_SOURCE,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
